import { Button } from '@platform/components';

const CTACard = ({
  title,
  description,
  signUpUrl,
}: {
  title: string;
  description: string;
  signUpUrl: string;
}) => {
  // TODO: This is a nonstandard shadow because the one supplied in the mocks is nearly impossible to see,
  // and our standard shadows don't fare much better due to the bkg colors involved.
  const shadow =
    '0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)';
  return (
    <div className='pt-16 bg-white'>
      <div className='bg-white px-4'>
        <div
          className='relative max-w-[1440px] mx-auto px-6 sm:px-16 pt-10 sm:pt-16 pb-6 rounded-2xl rounded-b-none bg-[#FAFAFA]'
          style={{
            boxShadow: shadow,
          }}
        >
          {/* TODO: Ask Julissa if the non-standard #FAFAFA color above is intentional */}
          <div className='sm:max-w-[768px] text-3xl font-semibold leading-9 text-gray-800'>
            {title}
          </div>
          {/* Floating button for desktop */}
          <div className='hidden sm:block sm:absolute sm:top-[-20px] sm:right-0 sm:m-16'>
            {/* TODO: Should be 60px on desktop */}
            <Button variant='primary' size='2xl' href={signUpUrl}>
              Get started
            </Button>
          </div>
        </div>
      </div>
      <div className='bg-brand-500 pb-16 px-4'>
        <div
          className='max-w-[1440px] mx-auto px-6 sm:px-16 pt-2 pb-10 sm:pb-16 -mt-4 rounded-2xl rounded-t-none bg-[#FAFAFA]'
          style={{
            // Clip rendering to avoid showing the box shadow on top of the adjacent div
            clipPath: 'inset(0px -50px -50px -50px)',
            boxShadow: shadow,
          }}
        >
          {/* Styled like a <Description> but without the built in padding */}
          <div className='sm:max-w-[768px] text-xl leading-7 text-gray-500'>{description}</div>
          {/* Floating button for desktop */}
          <div className='sm:hidden mt-8'>
            {/* TODO: Should be 60px on desktop */}
            <Button variant='primary' size='xl' href={signUpUrl}>
              Get started
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CTACard;
